import {selectNotifier} from '../selectNotifier';
import {expose} from '../expose';

interface FactorySettings {
  publisherFactory: PublisherFactory;
}

export function createReceiver(settings: FactorySettings): Receiver {
  const {publisherFactory} = settings;
  const observers: PublishersPool = {};

  return {
    on(name: MessageName, subscriber: Subscriber) {
      observers[name] = observers[name] || publisherFactory();
      observers[name].subscribe(subscriber);
    },
    off(name: MessageName, subscriber: Subscriber) {
      if (!observers[name]) return;
      observers[name].unsubscribe(subscriber);
    },
    register(scope: Window = window) {
      expose((message: Message) => selectNotifier(message, observers), scope);
    },
  };
}
